import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  FaChartArea,
  FaChartBar,
  FaChartLine,
  FaChartPie,
  FaHome,
  FaImages,
} from "react-icons/fa";
import { GiMayanPyramid, GiRadarCrossSection } from "react-icons/gi";
import styles from "./styles.module.css";

const BottomTab = (props) => {
  const { isMobile } = props;
  const [selected, setSelected] = useState("");
  let location = useLocation();

  useEffect(() => {
    let urlsArray = location.pathname.split("/");
    if (urlsArray.length > 1) {
      if (urlsArray.some((urls) => urls.startsWith("gallery"))) {
        setSelected("/gallery");
      } else if (urlsArray.some((urls) => urls === "barcharts")) {
        setSelected("/barcharts");
      } else if (urlsArray.some((urls) => urls === "barchart")) {
        setSelected("/barchart");
      } else if (urlsArray.some((urls) => urls === "horizbar")) {
        setSelected("/horizbar");
      } else if (urlsArray.some((urls) => urls === "stackbar")) {
        setSelected("/stackbar");
      } else if (urlsArray.some((urls) => urls === "linechart")) {
        setSelected("/linechart");
      } else if (urlsArray.some((urls) => urls === "areachart")) {
        setSelected("/areachart");
      } else if (urlsArray.some((urls) => urls === "piechart")) {
        setSelected("/piechart");
      } else if (urlsArray.some((urls) => urls === "radarchart")) {
        setSelected("/radarchart");
      } else if (urlsArray.some((urls) => urls === "popnpyramid")) {
        setSelected("/popnpyramid");
      } else {
        setSelected("/");
      }
    } else {
      setSelected("/");
    }
  }, [location.pathname]);

  return (
    <div className={styles.container}>
      <div style={{ display: "flex", justifyContent: "space-evenly" }}>
        {/* <NavLink
          onClick={() => setSelected("/")}
          className={selected === "/" ? styles.selectedText : styles.text}
          to="/"
        >
          <FaHome />
        </NavLink> */}

        <NavLink
          onClick={() => setSelected("/barchart")}
          className={
            (
              isMobile
                ? selected === "/barchart" ||
                  selected === "/horizbar" ||
                  selected === "/stackbar"
                : selected === "/barchart"
            )
              ? styles.selectedText
              : styles.text
          }
          to="/barchart"
        >
          <FaChartBar />
        </NavLink>

        {isMobile ? null : (
          <>
            <NavLink
              onClick={() => setSelected("/horizbar")}
              className={
                selected === "/horizbar" ? styles.selectedText : styles.text
              }
              to="/horizbar"
            >
              <img
                src={
                  selected === "/horizbar"
                    ? require("../../assets/horBarSelected.svg").default
                    : require("../../assets/horbar.svg").default
                }
                className={styles.iconStyle}
                alt=""
              />
            </NavLink>
            <NavLink
              onClick={() => setSelected("/stackbar")}
              className={
                selected === "/stackbar" ? styles.selectedText : styles.text
              }
              to="/stackbar"
            >
              <img
                src={
                  selected === "/stackbar"
                    ? require("../../assets/stack.svg").default
                    : require("../../assets/stackWhite.svg").default
                }
                className={styles.iconStyle}
                alt=""
              />
            </NavLink>
          </>
        )}
        <NavLink
          onClick={() => setSelected("/linechart")}
          className={
            (
              isMobile
                ? selected === "/areachart" || selected === "/linechart"
                : selected === "/linechart"
            )
              ? styles.selectedText
              : styles.text
          }
          to="/linechart"
        >
          <FaChartLine />
        </NavLink>
        {isMobile ? null : (
          <NavLink
            onClick={() => setSelected("/areachart")}
            className={
              selected === "/areachart" ? styles.selectedText : styles.text
            }
            to="/areachart"
          >
            <FaChartArea />
          </NavLink>
        )}
        <NavLink
          onClick={() => setSelected("/piechart")}
          className={
            selected === "/piechart" ? styles.selectedText : styles.text
          }
          to="/piechart"
        >
          <FaChartPie />
        </NavLink>
        <NavLink
          onClick={() => setSelected("/radarchart")}
          className={
            selected === "/radarchart" ? styles.selectedText : styles.text
          }
          to="/radarchart"
        >
          <GiRadarCrossSection />
        </NavLink>
        <NavLink
          onClick={() => setSelected("/popnpyramid")}
          className={
            selected === "/popnpyramid" ? styles.selectedText : styles.text
          }
          to="/popnpyramid"
        >
          <GiMayanPyramid />
        </NavLink>
        <NavLink
          onClick={() => setSelected("/gallery")}
          className={
            selected === "/gallery" ? styles.selectedText : styles.text
          }
          to="/gallery"
        >
          <FaImages />
        </NavLink>
      </div>
    </div>
  );
};

export default BottomTab;
